import { useTheme } from "@mui/material";
import { useFormikContext } from "formik";
import React from "react";

import FullLogoPrimary from "@/assets/logos/full-logo-secondary.png";
import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import { SubscribeFormData } from "@/components/templates/SubscribeForm/types";

const getProductImage = (productImage: string | undefined): string => {
  return productImage ? `data:image/jpeg;base64,${productImage}` : FullLogoPrimary;
};

export default function ProductImage() {
  const theme = useTheme();
  const imageWidth = theme.margins.giant * 1.6;
  const imageHeight = theme.margins.giant * 1.6;

  const { values } = useFormikContext<SubscribeFormData>();
  const { salesProduct, salesProductPrice } = values;
  const { productImage, name } = salesProduct;
  const { planName } = salesProductPrice;

  const imageSrc = getProductImage(productImage);

  return (
    <MDBox p={3} width="100%">
      <MDBox mt={1} width="100%" display={"flex"} justifyContent={"center"} borderRadius="lg">
        <img
          width={imageWidth}
          height={imageHeight}
          src={imageSrc}
          alt={name}
          style={{ borderRadius: "50%" }}
        />
      </MDBox>

      <MDBox mt={2} display={"flex"} justifyContent={"center"}>
        <MDBox textAlign={"center"}>
          <MDTypography variant="h5" fontWeight={"bold"}>
            {name}
          </MDTypography>
          <MDTypography variant="h6" fontWeight={"bold"}>
            {planName}
          </MDTypography>
        </MDBox>
      </MDBox>
    </MDBox>
  );
}
